import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnter } from 'src/utils/changeEnter';

const ShortAnswerSurvey = () => {
  let currentIndex = useSelector(
    (state: any) => state.imageUpload.currentIndex
  );
  let text = useSelector((state: RootState) => state.editText.text);
  let btnText = useSelector((state: RootState) => state.buttons.btnText);

  const [selected, setSelected] = useState(-1);

  return (
    <div className="root_view">
      <div className="template">
        <div className="center_horizon top_wrapper">
          {currentIndex !== 0 ? (
            <button className="back_btn"></button>
          ) : (
            <div></div>
          )}
          <button className="close_btn"></button>
        </div>

        <div className="center_wrapper">
          <div className="title">
            <div className="title_inner">
              {changeEnter(text?.title?.[currentIndex])}
            </div>
          </div>
          <div className="logo">
            <button></button>
          </div>
          <div className="survey_wrapper">
            {btnText?.option_button?.[currentIndex]?.map(
              (survey: string, idx: number) => {
                return (
                  <>
                    <div
                      className="survey"
                      onClick={() => {
                        if (idx === selected) setSelected(-1);
                        else setSelected(idx);
                      }}
                    >
                      <span className="survey_radius">
                        {idx === selected && (
                          <div className="survey_action"></div>
                        )}
                      </span>
                      <p>{survey}</p>
                    </div>
                    {idx !==
                      btnText?.option_button?.[currentIndex]?.length - 1 && (
                      <hr className="hr" />
                    )}
                  </>
                );
              }
            )}
          </div>
          <textarea
            className="textarea"
            placeholder={btnText?.text_area?.[currentIndex]}
          ></textarea>
        </div>
        <div className="center_horizon bottom">
          <button className={'left_button ' + (selected !== -1 && 'action')}>
            {btnText?.left_button?.[currentIndex]}
          </button>
          <button className="right_button">
            {btnText?.right_button?.[currentIndex]}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShortAnswerSurvey;
